import { useEffect, useState } from "react";
import { useMetaMask } from "metamask-react";
import { useSelector, useDispatch } from "react-redux";
import Web3 from "web3";
import axios from "axios";
import { updateLocation } from "../../../redux/App/actions";
import { setRacerLogin } from "../../../redux/Account/actions";
import { setRacerXP, setRacerCoins } from "../../../redux/Account/actions";
import {axiosInstance, closeAllModals} from "../../../utils";

let web3;

export const SettingsModal = () => {
    const dispatch = useDispatch();
    const { racerID, accountAddress } = useSelector((state) => state.account);
    const { admin_racers } = useSelector((state) => state.app);
    const [pageSet, setPage] = useState(false);
    const [racer_handle, setRacerHandle] = useState('');
    const [racer_email, setRacerEmail] = useState('');
    const [racer_discord, setRacerDiscord] = useState('');
    const [start_email, setStartRacerEmail] = useState('');
    const [start_handle, setStartRacerHandle] = useState('');
    const [start_discord, setStartRacerDiscord] = useState('');

    function grabRacerInfo() {
        var addData = new Object();
        addData.racerID = encodeURIComponent(racerID);
        addData.walletID = encodeURIComponent(accountAddress);

        axiosInstance.post('member/details_list/',addData).then(result => {
            if(Object.keys(result.data).length > 0) {
                var racer_details = result.data;
                setRacerHandle(result.data[0].racer_name);
                setRacerEmail(result.data[0].racer_email);
                setRacerDiscord(result.data[0].racer_discord);
                setStartRacerHandle(result.data[0].racer_name);
                setStartRacerEmail(result.data[0].racer_email);
                setStartRacerDiscord(result.data[0].racer_discord);
                window.M.updateTextFields();
            }
        }).catch(error => {
            console.log(error);
            //dispatch(updateLocation("staging"));
        });
    }

    function saveSettings(e) {
        e.preventDefault();

        var raceremail = document.getElementById("settingsEmail").value;
        var racerhandle = document.getElementById("settingsRacerHandle").value;
        var racerdiscord = document.getElementById("settingsRacerDiscord").value;

        var addData = new Object();
        addData.racerID = encodeURIComponent(racerID);
        addData.walletID = encodeURIComponent(accountAddress);
        if(start_email !== raceremail) {
            addData.racerEmail = encodeURIComponent(raceremail);
        }
        if(start_handle !== racerhandle) {
            addData.racerHandle = encodeURIComponent(racerhandle);
        }
        if(start_discord !== racerdiscord) {
            addData.racerDiscord = encodeURIComponent(racerdiscord);
        }
        if((start_handle !== racerhandle)&&(racerhandle.length < 3)) {
            alert('Pick a Longer Racer Handle. Handles Must be atleast 3 Letters or Numbers Long.');
        } else {
            document.getElementById("settingssubmit").style.display = 'none';
            document.getElementById("settingsloading").style.display = 'block';
            axiosInstance.post('member/settings_update/',addData).then(result => {
                if(Object.keys(result.data).length > 0) {
                    var save_result = result.data;
                    setTimeout(function(){
                        document.getElementById("settingssubmit").style.display = 'block';
                        document.getElementById("settingsloading").style.display = 'none';
                        if(save_result.save_status.includes("success")) {
                            window.M.toast({html: 'Settings Saved!', displayLength: 2000});
                        } else if(save_result.save_status.includes("error_email")) {
                            alert('This Email is Already Taken. Update and Try Again.');
                        } else if(save_result.save_status.includes("error_handle")) {
                            alert('This Racer Handle is Already Taken. Update and Try Again.');
                        } else if(save_result.save_status.includes("error_discord")) {
                            alert('This Discord Handle is Already Signed Up. Update and Try Again.');
                        } else {
                            alert('Whoops! Something Went Wrong. Update and Try Again');
                        }
                    },2000);
                }
            }).catch(error => {
                console.log(error);
            });
        }
    }

    if(pageSet == false) {
        setPage(true);
        grabRacerInfo();
    }

    function onEmailTextChange(e){
        setRacerEmail(e.target.value);
    }

    function onHandleTextChange(e){
        setRacerHandle(e.target.value);
    }

    function onDiscordTextChange(e){
        setRacerDiscord(e.target.value);
    }

    function goToTerms() {
        window.location.href= '/#/terms';
        dispatch(updateLocation("terms"));
    }

    function logoutGame() {
        dispatch(setRacerLogin('',''));
        dispatch(updateLocation("splash"));
        window.location.href= '/';
    }

    return(<div id="settingsbox" className="col s12 modal page-modal page-modal-smedium page-modal-right">
            <div className="modal-content">
                <div className="row" style={{marginBottom:'5px',position:'relative'}}>
                    <div className="round-close-button" style={{right:'-10px'}} title="Close" onClick={()=>closeAllModals()}>
                        X
                    </div>
                    <div className="col s12" style={{fontSize:"24px",marginTop:"0px",padding:"0px"}}>
                        <div className="left headline-text" style={{marginLeft:'5px'}}>MY ACCOUNT</div>
                        
                    </div>
                    <div className="col s12" style={{padding:"0px 5px"}}>
                        <div className="divider-thin"></div>
                    </div>
                    <div className="col s12 subheadline-text" style={{fontSize:'16px',borderRadius:'10px',marginTop:'20px'}}>
                        <div className="row" style={{display:'flex',flexDirection:'row',padding:'10px',marginBottom:'10px'}}>
                            <div style={{order:'1',flexBasis:'130px',marginTop:'3px',textAlign:'right'}}>
                                Wallet Address:&nbsp;&nbsp;
                            </div>
                            <div style={{order:'2',flex:'10'}} title="Log Back In With A Different Wallet to Change">
                                <input value={accountAddress} 
                                        id="walletAddress" 
                                        type="text" 
                                        className="browser-default light-grey-bubble-input"
                                        style={{width:'98%',cursor:'not-allowed'}}
                                        title="Log Back In With A Different Wallet to Change"
                                        disabled />
                            </div>
                        </div>
                        <div className="row" style={{display:'flex',flexDirection:'row',padding:'10px',marginBottom:'10px'}}>
                            <div style={{order:'1',flexBasis:'130px',marginTop:'3px',textAlign:'right'}}>
                                Email Address:&nbsp;&nbsp;
                            </div>
                            <div style={{order:'2',flex:'10'}}>
                                <input value={racer_email} 
                                        onChange={onEmailTextChange} 
                                        id="settingsEmail" 
                                        type="email" 
                                        className="browser-default light-grey-bubble-input"
                                        style={{width:'98%'}} />
                            </div>
                        </div>
                        <div className="row" style={{display:'flex',flexDirection:'row',padding:'10px',marginBottom:'10px'}}>
                            <div style={{order:'1',flexBasis:'130px',marginTop:'3px',textAlign:'right'}}>
                                Racer Handle:&nbsp;&nbsp;
                            </div>
                            <div style={{order:'2',flex:'10'}}>
                                <input value={racer_handle} 
                                    onChange={onHandleTextChange} 
                                    id="settingsRacerHandle" 
                                    type="text" 
                                    className="browser-default light-grey-bubble-input" 
                                    style={{width:'98%'}} />
                            </div>
                        </div>
                        <div className="row" style={{display:'flex',flexDirection:'row',padding:'10px',marginBottom:'30px'}}>
                            <div style={{order:'1',flexBasis:'130px',marginTop:'3px',textAlign:'right'}}>
                                Discord Handle:&nbsp;&nbsp;
                            </div>
                            <div style={{order:'2',flex:'10'}}>
                                <input value={racer_discord} 
                                    onChange={onDiscordTextChange} 
                                    id="settingsRacerDiscord" 
                                    type="text" 
                                    className="browser-default light-grey-bubble-input" 
                                    style={{width:'98%'}} />
                            </div>
                        </div>
                    </div>
                    <div className="col s12" style={{marginTop:'-20px'}}>
                        <div id="settingssubmit" className="right" title="Save Account Settings">
                            <span type="submit" className="round-border-button" style={{fontSize:'16px',paddingTop:'8px'}} title="SAVE SETTINGS" onClick={(e)=>saveSettings(e)}>
                                SAVE PROFILE
                            </span>
                        </div>
                        <div id="settingsloading" className="preloader-wrapper small active right splash-modal-loader" style={{height:'30px',width:'30px',marginTop:'3px'}}>
                            <div className="spinner-layer spinner-red-only">
                                <div className="circle-clipper left">
                                    <div className="circle"></div>
                                </div>
                                <div className="gap-patch">
                                    <div className="circle"></div>
                                </div>
                                <div className="circle-clipper right">
                                    <div className="circle"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col s12" style={{padding:"0px 5px",marginTop:'20px'}}>
                        <div className="divider-thin"></div>
                    </div>
                    <div className="col s12" style={{marginTop:'10px'}}>
                        <div id="logoutbutton" className="left" style={{marginTop:'5px'}} title="Logout From Game">
                            <span className="round-border-button" style={{fontSize:'14px',paddingTop:'6px'}} title="Logout From Game" onClick={()=>logoutGame()}>
                                LOGOUT
                            </span>
                        </div>
                        <div className="right-align" style={{marginTop:'5px'}} title="Terms of Service">
                            <a className="white-red-link" style={{fontSize:'14px',paddingTop:'6px'}} target="_blank" href="/#/terms">
                               Terms
                            </a>&nbsp;&nbsp;|
                            &copy; 2023, Exiled Studios Inc
                        </div>
                    </div>
                </div>
            </div>
        </div>);
};